export default "__VITE_ASSET__CsdLY9Fz__"